import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getUserListData, getUserListTotal, getLoadingStatus } from '../../redux/user/selectors';
import { userActions } from '../../redux/user/actions';

export const useUserListData = () => {
  const dispatch = useDispatch();
  const userListData = useSelector(getUserListData);
  const userListTotal = useSelector(getUserListTotal);
  const loading = useSelector(getLoadingStatus);

  useEffect(() => {
    dispatch(userActions.loadUserList());
  }, [dispatch]);

  return { userListData, userListTotal, loading };
};
